module.exports = new __parcel__URL__("bfg.9bed7f8e.webp").toString();